import { s } from '@/theme/tokens';
import { Inline } from '@/ui/layout/Inline';
import { PageHeader } from '@/ui/layout/PageHeader';
import { Section } from '@/ui/layout/Section';
import { Stack } from '@/ui/layout/Stack';
import { Box, PageShell } from '@/ui/primitives';
import type { SpacingToken } from '@/theme/tokens';
import type { ReactElement, ReactNode } from 'react';

type DetailPageTemplateProps = {
  title: ReactNode;
  status?: ReactNode;
  headerMeta?: ReactNode;
  headerActions?: ReactNode;
  metadata?: ReactNode;
  summary?: ReactNode;
  primaryContent?: ReactNode;
  secondaryContent?: ReactNode;
  paddingTop?: SpacingToken;
  paddingBottom?: SpacingToken;
};

export const DetailPageTemplate = ({
  title,
  status,
  headerMeta,
  headerActions,
  metadata,
  summary,
  primaryContent,
  secondaryContent,
  paddingTop = 'md',
  paddingBottom = 'lg',
}: DetailPageTemplateProps): ReactElement => (
  <PageShell
    maxWidth="xl"
    paddingX="lg"
    paddingY="xl"
    paddingTop={paddingTop}
    paddingBottom={paddingBottom}
  >
    <Stack gap="none">
      <Section paddingY="sm">
        <Box sx={{ borderBottom: 1, borderColor: 'divider', pb: s('lg') }}>
          <PageHeader
            title={
              <Inline gap="md" align="center" wrap="wrap">
                {title}
                {status}
                {headerMeta}
              </Inline>
            }
            actions={headerActions}
          />
        </Box>
      </Section>
      {metadata}
      {summary}
      {primaryContent}
      {secondaryContent}
    </Stack>
  </PageShell>
);
